import { Permission } from '@cims-online/shared'
import { RestoreRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { useFDCTrackerContext } from '../../../FDCTrackerContext'
import { FieldDesignChange } from '../../../FDCTrackerContext/types'

export function useRestoreOptions(): RestoreRowActionOptions<FieldDesignChange> {
  const {
    fieldDesignChanges,
    mutations: { restore },
  } = useFDCTrackerContext()
  return {
    permission: Permission.RemoveRestoreFieldDesignChange,
    onRestore: async ({ id }) => {
      await restore.fn({ variables: { id } })
      fieldDesignChanges?.refetch()
    },
    default: 'active',
    metadata: ({ deleted, deletedUser, deletedDate }) => ({
      removed: deleted,
      removedBy: deletedUser,
      removedDate: deletedDate,
    }),
  }
}
